import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientConfig,
} from '@tanstack/react-query';
import { captureApiError } from '../sentry';

export const createReportingCachesConfig = (): QueryClientConfig => ({
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureApiError(error, { queryKey: query.queryKey.join('.') });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      captureApiError(error);
    },
  }),
});

export const queryClient = new QueryClient(createReportingCachesConfig());
